import { MARKET } from "../config/market";

/** Prefixes are a guide, not proof of an active wallet. Unknown ranges remain usable. */
export function validatePaymentPhone(raw, methodKey, market = MARKET) {
  const text = String(raw || "").trim();
  const invalid = { ok: false, message: `Enter a valid ${market.name} mobile money number.` };
  if (!text || !/^\+?[\d\s()-]+$/.test(text)) return invalid;
  let digits = text.replace(/\D/g, "");
  if (digits.startsWith("00")) digits = digits.slice(2);
  if (text.startsWith("+") || digits.length === 12) {
    if (!digits.startsWith(market.dialCode) || digits.length !== 12) return invalid;
    digits = `0${digits.slice(3)}`;
  } else if (digits.length === 9 && !digits.startsWith("0")) {
    digits = `0${digits}`;
  }
  if (!/^0\d{9}$/.test(digits)) return invalid;
  const ranges = Object.entries(market.momoPrefixes || {});
  if (ranges.length && !ranges.some(([, prefixes]) => prefixes.some((prefix) => digits.startsWith(prefix.slice(0, 2))))) return invalid;

  const known = ranges.find(([, prefixes]) =>
    prefixes.some((prefix) => digits.startsWith(prefix))
  );
  if (known && known[0] !== methodKey) {
    const network = { MOMO: "MTN Mobile Money", Airtel: "Airtel Money", ZAMTEL: "Zamtel Kwacha" }[known[0]];
    return {
      ok: false,
      local: digits,
      suggestedKey: known[0],
      message: `This number looks like ${network}. Choose ${network} or enter a number for the selected network.`,
    };
  }
  return {
    ok: true,
    local: digits,
    message: known ? "" : "We could not identify this number’s network. Check that it matches your payment choice.",
  };
}
